import {translate} from 'vue-gettext'

const {gettext: $gettext} = translate

const SalesReport = () => import('./SalesReport.vue')

export default [
    {
        path: 'sales-report',
        name: 'salesReport',
        component: SalesReport,
        meta: {
            title: $gettext('Sales report'),
            label: $gettext('Sales report'),
            perms: ['admin.stats.sales_report', 'admin.stats.saas_payments_total', 'admin.stats.saas_payments_list']
        }
    }
]